import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Scottsdale, AZ?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office in Scottsdale can take 2–6 months, especially during peak travel seasons. For Mayo Clinic physicians, Barrett-Jackson collectors, and resort executives on tight timelines, that simply is not viable.",
  },
  {
    q: "Do I need to drive to Los Angeles to get an emergency passport from Scottsdale?",
    a: "No — that is exactly why Fast Passport Center exists. The nearest regional passport agency to Scottsdale is the Los Angeles Passport Agency, about 370 miles away via I-10 West. Getting an appointment there is unpredictable and requires taking an entire day or more. Fast Passport Center eliminates that trip entirely through reserved courier submission. You start online, ship your documents overnight, and we handle the rest.",
  },
  {
    q: "Can Mayo Clinic or HonorHealth physicians get a passport fast for an international conference?",
    a: "Absolutely. Medical professionals traveling to international conferences and CME programs are one of our most common Scottsdale client types. Conference schedules are fixed and non-negotiable. We regularly process expedited renewals and replacements for Scottsdale-area physicians with 5–14 day lead times before major international medical meetings in Europe and Asia.",
  },
  {
    q: "I attend the Barrett-Jackson auction and travel internationally for collector events. How can I get a passport renewed quickly?",
    a: "Collector car travel — to Concours d\u2019Elegance events in France, Goodwood in England, Japanese classic car events — often requires current passports on short notice. We handle expedited renewals for Scottsdale automotive collectors regularly. Start your order online, ship your documents overnight from home, and we handle the rest through reserved agency submission.",
  },
  {
    q: "Can Scottsdale residents get a child\u2019s passport fast for a Mexico resort trip?",
    a: "Yes. Child passports (for minors 15 and under) require an in-person acceptance clerk step and consent from both parents. We provide a clear, step-by-step checklist for Scottsdale families so the process is straightforward. Most Mexico resort destinations — especially Los Cabos and Puerto Vallarta — require passports for all passengers, including children, for any air travel.",
  },
  {
    q: "How do I get a passport photo in Scottsdale before applying?",
    a: "Passport photos are available at CVS, Walgreens, FedEx Office, The UPS Store, and other locations throughout Scottsdale and North Scottsdale. Your photo must meet strict U.S. State Department specifications — neutral expression, white or off-white background, no glasses. We provide exact requirements so you get it right the first time and avoid rejection.",
  },
  {
    q: "What if my Scottsdale trip to Mexico is next week and my passport just expired?",
    a: "This is one of the most common situations we handle. If your Mexico trip is within the next 2 weeks, start your order immediately. For most Scottsdale renewal applicants, we can complete expedited processing in 2–9 business days depending on the option selected. In genuine emergencies with documented travel within 3 days, we have fastest available options. Contact us as soon as possible — every day matters.",
  },
  {
    q: "Do I need to visit a Fast Passport Center office in Scottsdale?",
    a: "No — there is no local Fast Passport Center office in Scottsdale, and you do not need one. Start your order online from your Scottsdale home or office, follow the personalized checklist we send you, and ship your documents overnight from any UPS or FedEx location in the area. We handle all agency submission remotely through our reserved courier access.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability — at lower cost than resellers like FedEx or Staples.",
  },
];

export default function ScottsdaleFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Scottsdale and Northeast Phoenix metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}